import { createAction, props } from '@ngrx/store';

import { LoadUserStrategy, UserEntity } from './model';

export const upsertUserEntities = createAction(
  '[User entities]: Upsert user entities',
  props<{ entities: UserEntity[] }>(),
);

/**
 * Updates imagelink for a user entity
 */
export const updateUserEntityImage = createAction(
  '[User entities]: Update image for user',
  props<{ externalId: string; imageLink: string }>(),
);

/**
 * Fetches user by external ids.
 * @param {number[]} ids array of external ids
 * @param {'lazy' | 'eager'} strategy Fetching strategy
 *    lazy: doesn't fetch if user is in state
 *    eager: fetches the value no matter state
 */
export const loadUsers = createAction(
  '[User entities]: Load users',
  props<{ ids: string[]; strategy?: LoadUserStrategy }>(),
);
